module.exports = __webpack_public_path__ + "img/skull_18.c2e95706.png";